module.exports = __webpack_public_path__ + "static/media/gems-sensing-logo.4267e9af.png";